<template>
  <MainLayout>
    <div class="all-suggestion-users-page container py-5 home-container">
      <h1 class="mb-4 text-center title-white">En Çok Fikir Veren Tüm Kişiler</h1>
      <div v-if="loading" class="text-center">
        <div class="spinner"></div>
      </div>
      <div v-else-if="error" class="alert alert-danger">
        <p>Kullanıcılar yüklenirken bir hata oluştu.</p>
      </div>
      <div v-else>
        <div class="user-list-item d-flex align-items-center p-3 mb-3 bg-white shadow-sm" v-for="item in paginatedUsers"
          :key="item.UserId">
          <img v-if="item.UserPictureId != 0 && item.UserProfileImage"
            class="flex-shrink-0 user-avatar fallback-image mr-3"
            :src="`data:image/png;base64, ${item.UserProfileImage}`" :alt="item.UserName | getInitialsFilter" />
          <i v-else
            class="flex-shrink-0 user-avatar fallback-image mr-3 d-flex align-items-center justify-content-center"
            :alt="item.UserName | getInitialsFilter">{{ item.UserName | getInitialsFilter }}</i>
          <div class="user-info">
            <span class="d-block font-weight-bold">{{ item.UserName }}</span>
            <span class="d-block text-muted">{{ item.CompanyName }}</span>
            <span class="d-block">Fikir Sayısı: {{ item.SuggestionCount }}</span>
          </div>
        </div>

        <nav aria-label="Page navigation" v-if="totalPages > 1">
          <ul class="pagination justify-content-center">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Önceki</a>
            </li>
            <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
              <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
              <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Sonraki</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "../layouts/MainLayout.vue"; // Import MainLayout
import { getInitials } from "../helpers";

export default {
  name: "MostSuggestionAllUsers",
  components: {
    MainLayout, // Register MainLayout
  },
  data() {
    return {
      loading: false,
      error: false,
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  watch: {
    allUsers() {
      if (this.allUsers.length > 0) {
        this.loading = false;
      }
    },
  },
  filters: {
    getInitialsFilter(value) {
      if (!value) return "";
      return getInitials(value);
    },
  },
  computed: {
    allUsers() {
      return this.$store.getters["mostSuggestionUsers/mostSuggestionUsersData"] || [];
    },
    totalPages() {
      return Math.ceil(this.allUsers.length / this.itemsPerPage);
    },
    paginatedUsers() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.allUsers.slice(start, end);
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    async fetchUsers() {
      if (!this.allUsers || this.allUsers.length === 0) {
        this.loading = true;
        this.error = false;
        try {
          await this.$store.dispatch("mostSuggestionUsers/setMostSuggestionUsers");
        } catch (err) {
          this.error = true;
        }
      }
    }
  },
  created() {
    this.fetchUsers();
  },
};
</script>

<style scoped>
.home-container {
  background-image: url("~@/assets/images/background.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.title-white {
  color: white;
}

.all-suggestion-users-page {
  max-width: 100%;
}

.user-list-item {
  max-width: 800px;
  border-radius: 8px;
  transition: box-shadow 0.3s ease-in-out;
  margin-left: auto;
  margin-right: auto;
}

.user-list-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.user-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  font-size: 1.5rem;
  background-color: #e9ecef;
  color: #495057;
}

.user-info span {
  font-size: 0.95rem;
}

.user-info .font-weight-bold {
  font-size: 1.1rem;
  color: #333;
}

.text-muted {
  color: #6c757d !important;
  font-size: 0.85rem;
}

.page-link {
  color: #007bff;
}

.page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.page-item.disabled .page-link {
  color: #6c757d;
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #fff;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
